// Firebase 설정 및 초기화
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase 환경 변수 검증
const validateFirebaseConfig = () => {
  const requiredEnvVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_STORAGE_BUCKET',
    'VITE_FIREBASE_MESSAGING_SENDER_ID',
    'VITE_FIREBASE_APP_ID'
  ];

  const missingVars = requiredEnvVars.filter(
    varName => !import.meta.env[varName]
  );

  if (missingVars.length > 0) {
    throw new Error(`Missing Firebase environment variables: ${missingVars.join(', ')}`);
  }
};

// 개발 환경에서만 Firebase 설정 정보 출력
const logFirebaseConfig = () => {
  if (import.meta.env.DEV) {
    console.log('🔧 Firebase Config Check:');
    console.log('- API Key:', import.meta.env.VITE_FIREBASE_API_KEY ? '✅ Set' : '❌ Missing');
    console.log('- Auth Domain:', import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ? '✅ Set' : '❌ Missing');
    console.log('- Project ID:', import.meta.env.VITE_FIREBASE_PROJECT_ID ? '✅ Set' : '❌ Missing');
    console.log('- Storage Bucket:', import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ? '✅ Set' : '❌ Missing');
    console.log('- Messaging Sender ID:', import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ? '✅ Set' : '❌ Missing');
    console.log('- App ID:', import.meta.env.VITE_FIREBASE_APP_ID ? '✅ Set' : '❌ Missing');
    console.log('- Environment:', import.meta.env.MODE);
    console.log('- Debug Mode:', import.meta.env.DEV);
    console.log('- Use Emulator:', import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true');
  }
};

// Firebase 설정 객체
let firebaseConfig;
let app;
let auth;
let db;
let storage;

try {
  // 환경 변수 검증
  validateFirebaseConfig();
  
  // Firebase 설정 정보 출력
  logFirebaseConfig();

  // Firebase 설정
  firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
  };

  // Firebase 앱 초기화 (중복 방지)
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
  
  // Firebase 서비스 초기화
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);

  // 초기화 성공 로그
  if (import.meta.env.DEV) {
    console.log('🔥 Firebase initialized successfully!');
    console.log('📋 Project ID:', firebaseConfig.projectId);
    console.log('🎯 Mode:', import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true' ? 'Emulator' : 'Production');
  }
} catch (error) {
  console.error('Firebase initialization failed:', error);
  // 프로덕션에서는 에러 리포팅 서비스로 전송
  throw error;
}

export { auth, db, storage };
export default app;